<template>
  <div class="container">
    <v-fade-transition>
      <div
        v-show="
          [ROUTE_HOME, ROUTE_SALE].includes(route.name) &&
          latestTransactions.length
        "
        class="latest-transactions-carousel mb-4 mr-n2"
      >
        <Carousel
          dir="rtl"
          :options="{ currentPage: 0 }"
          snap-align="start"
          :autoplay="2000"
          :transition="1000"
          :items-to-show="4"
          :breakpoints="{
            1680: { itemsToShow: 7 },
            1280: { itemsToShow: 5 },
            780: { itemsToShow: 3 },
            480: { itemsToShow: 2 },
            100: { itemsToShow: 1 },
          }"
          :mouse-drag="false"
          pause-autoplay-on-hover
        >
          <Slide
            v-for="transaction in latestTransactions"
            :key="transaction.hash"
          >
            <v-card
              class="mr-2 latest-trades-item"
              :to="{
                name: ROUTE_SALE,
                params: { contractAddress: transaction.token.sale_address },
              }"
            >
              <v-card-text class="py-2 px-2">
                <div
                  class="d-flex flex-row-reverse align-center justify-space-between"
                >
                  <span
                    v-text="formatAddress(transaction.address)"
                    class="opacity-80"
                  />

                  <v-chip
                    class="font-heading tx-type-chip"
                    :color="
                      transaction.tx_type === TX_FUNCTIONS.sell
                        ? 'error'
                        : 'success'
                    "
                  >
                    {{
                      transaction.tx_type === TX_FUNCTIONS.sell
                        ? "sold"
                        : "bought"
                    }}
                  </v-chip>
                </div>
                <div class="d-flex flex-row-reverse align-center ga-2 pt-1">
                  <span class="text-primary price">
                    {{ Decimal.from(transaction?.volume).shorten() }}
                  </span>
                  <div dir="ltr" style="width: 80%">
                    <TextTruncate
                      :str="transaction.token.name"
                      class="symbol font-heading"
                    />
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </Slide>
        </Carousel>
      </div>
    </v-fade-transition>
  </div>
</template>

<script lang="ts" setup>
import "vue3-carousel/dist/carousel.css";
// https://ismail9k.github.io/vue3-carousel/examples.html
import { Carousel, Slide } from "vue3-carousel";

import { useRoute } from "vue-router";
import { onMounted } from "vue";

import { TX_FUNCTIONS, ROUTE_SALE, ROUTE_HOME } from "@/utils/constants";
import { formatAddress } from "@/utils";
import { useLatestTransactions } from "@/composables";
import { TransactionsService } from "@/api/generated";
import { Decimal } from "@/libs/decimal";

import TextTruncate from "@/components/Common/TextTruncate.vue";

const route = useRoute();
const { latestTransactions } = useLatestTransactions();

onMounted(() => {
  TransactionsService.listTransactions({
    limit: 10,
    includes: "token",
  }).then((response: any) => {
    latestTransactions.value = response.items;
  });
});
</script>

<style lang="scss" scoped>
@use "@/styles/variables" as *;

.latest-transactions-carousel {
  .text-h4 {
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px; /* 88.889% */
    letter-spacing: 1.44px !important;
    text-transform: uppercase;
    display: flex;
    padding: 8px 12px 8px 0px;
    margin-bottom: 12px;
    align-items: center;
    gap: 8px;
  }

  .latest-trades-item {
    width: 100%;
    overflow: hidden;

    .tx-type-chip {
      height: auto !important;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 9px;
      padding: 5px 7px 2px;
    }

    .price {
      font-size: 14px;
      font-weight: bold;
      line-height: 18px; /* 16px */
    }

    .symbol {
      font-size: 11px !important;
      font-style: normal;
      font-weight: 600;
      letter-spacing: -0.8px !important;
      line-height: 13px;
    }
  }

  .amount {
    font-weight: 500;
    font-size: 13px !important;
  }
}
</style>
